import React from 'react';
import { formatDateEs } from '../../utils';
import './PatientsTable.css';

const PatientsTable = ({ patients, onView, onRestore, readOnly = false }) => {
  return (
    <div className="patients-table-container">
      <table className="patients-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th>Fecha de Nacimiento</th>
            {readOnly && <th>Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {patients.map((patient) => (
            <tr 
              key={patient.id} 
              className={readOnly ? 'read-only-row' : 'clickable-row'}
              onClick={() => !readOnly && onView && onView(patient)}
              style={readOnly ? { cursor: 'default' } : {}}
            >
              <td className="patient-name">
                <div className="name-cell">
                  <div className="patient-avatar-small">
                    <i className="fas fa-user"></i>
                  </div>
                  <span>
                    {patient.firstName && patient.lastName 
                      ? `${patient.firstName} ${patient.lastName}` 
                      : 'No especificado'}
                  </span>
                  {readOnly && (
                    <span className="deleted-badge">
                      <i className="fas fa-archive"></i> Archivado
                    </span>
                  )}
                </div>
              </td>
              <td>{patient.email || '-'}</td>
              <td>{patient.phoneNumber || patient.cellPhone || '-'}</td>
              <td>{formatDateEs(patient.dateOfBirth)}</td>
              {readOnly && (
                <td onClick={(e) => e.stopPropagation()}>
                  <button 
                    className="restore-button"
                    onClick={() => onRestore && onRestore(patient)}
                    title="Restaurar paciente"
                  >
                    <i className="fas fa-undo"></i>
                    Restaurar
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PatientsTable;